import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React, { useRef, useState, useLayoutEffect } from "react";
import BlogPostThumbnailStyles from "./BlogPostThumbnail.styles";

const {
    Container,
    TextBoxOutline,
    TextBox,
    InsideTextContainer,
    CategoriesText,
    TitleText,
    DescText,
    ReadMoreLink,
} = BlogPostThumbnailStyles;

const BlogPostThumbnail = ({ post }) => {
    const image = getImage(post.thumbnail);
    const descRef = useRef(null);
    const [lines, setLines] = useState(3);

    useLayoutEffect(() => {
        setLines(Math.floor(descRef.current.clientHeight / 22));
    }, [descRef]);

    return (
        <Container>
            <GatsbyImage
                image={image}
                alt="Post thumbnail"
                style={{ zIndex: "1" }}
            />
            <TextBoxOutline>
                <TextBox>
                    <InsideTextContainer>
                        <CategoriesText>
                            {post.categories
                                .flatMap((elem) => elem.singleCategory)
                                .join(", ")}
                        </CategoriesText>
                        <TitleText>{"<" + post.title + ">"}</TitleText>
                        <DescText ref={descRef} lines={lines}>
                            {post.lead}
                        </DescText>
                        <ReadMoreLink to={"/blog/" + post.slug}>
                            Read more ...
                        </ReadMoreLink>
                    </InsideTextContainer>
                </TextBox>
            </TextBoxOutline>
        </Container>
    );
};

export default BlogPostThumbnail;
